import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const formatPrice = (value) =>
  new Intl.NumberFormat("ro-RO", { maximumFractionDigits: 0 }).format(value) + " lei";

export const CATEGORY_NAMES = {
  carucioare: "Cărucioare urbane",
  sport: "Cărucioare sport",
  multisport: "Remorci multisport",
  "scaune-auto": "Scaune auto",
  purtare: "Rucsacuri transport",
};
